import { inject, Injectable } from '@angular/core';
import { Params, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class QueryParamsResource {
  private router = inject(Router);

  getCurrent<T extends Params>() {
    const url = window.location.href.replace(window.location.origin, '');
    return this.router.parseUrl(url).queryParams as T;
  }
}
